module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"close_today":"오늘 하루 보지 않기"}}')
  delete Component.options._Ctor
}
